import GrmWorkerUtils from "@/lib/gooroomee/worker/grm-worker-utils";
import Worker from 'worker-loader!./ImageUtilsWorker.runner'
import {ImageUtils} from "@/lib/gooroomee/image-process/ImageUtils";

export const ImageUtilsWorker = (() => {
    let worker;
    let proxy;
    let creator;
    let listeners;

    const Proxy = {

    };

    return {
        async get () {
            if(proxy) return proxy;

            if(creator){
                listeners = listeners || [];
                return new Promise((resolve, reject) => {
                    listeners.push({resolve, reject});
                });
            }

            worker = new Worker();
            creator = GrmWorkerUtils.createWorkerProxy(ImageUtils, worker);
            proxy = await creator;
            Object.assign(proxy, Proxy);

            if(listeners && listeners.length > 0){
                creator = null;
                queueMicrotask(() => {
                    do{
                        listeners.shift().resolve(proxy);
                    }while(listeners.length > 0);
                    listeners = null;
                });
            }

            return proxy;
        }
    }
})();

